import { useCallback, useState } from "react";
import { RelatorioInadimplentesQueryParams } from "core/features/relatorios/typings/index";
import moment from "moment";

export const defaultFiltroRelatorioInadimplentes: RelatorioInadimplentesQueryParams =
  {
    search: "",
    dataPosicao: moment().endOf("day").format("YYYY-MM-DD"),
    dataInicio: undefined,
    dataFim: moment().endOf("day").format("YYYY-MM-DD"),
    contasBancariasIds: [],
    centrosDeCustoIds: [],
  };

function useFiltroRelatorioInadimplentes() {
  const [filtro, setFiltro] = useState<RelatorioInadimplentesQueryParams>(
    defaultFiltroRelatorioInadimplentes
  );

  const onChangeFiltro = useCallback(
    (_filtro: Partial<RelatorioInadimplentesQueryParams>) => {
      setFiltro((state) => ({ ...state, ..._filtro }));
    },
    []
  );

  const onResetFiltro = useCallback(() => {
    setFiltro(defaultFiltroRelatorioInadimplentes);
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroRelatorioInadimplentes;
